<template>
  <vue-recaptcha
    :style="getStyle"
    ref="recaptcha"
    :sitekey="getSiteKey"
    @verify="verifyRecaptcha"
    @expired="reset"
  />
</template>

<script>
import { VueRecaptcha } from "vue-recaptcha";

export default {
  components: {
    VueRecaptcha
  },

  computed: {
    getStyle() {
      return {
        display: "flex",
        "justify-content": "center",
        transform: "scale(0.77)",
        "-webkit-transform": "scale(0.77)"
      };
    },
    getSiteKey() {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY;
    }
  },

  methods: {
    verifyRecaptcha(recaptchaToken) {
      this.$emit("update:recaptchaToken", recaptchaToken);
    },

    reset() {
      this.$emit("update:recaptchaToken", null);
      this.$refs.recaptcha.reset();
    }
  }
};
</script>

<style></style>
